import React, {Component} from "react";

export default class InfoBanner extends Component {
    render() {
        return (
            <div className="ps-section__right">
                
                <div className="ps-section__content">
                    <div className="row">
                        <div className="col-4">
                            <div className="ps-block--award">
                                <div className="ps-block__header"><img src="/img/icon/ersal-sari.png" alt=""/>
                                    <h4>ارسال سریع</h4>
                                </div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="ps-block--award">
                                <div className="ps-block__header"><img src="/img/icon/tame-vagheie-nan.png" alt=""/>
                                    <h4>طعم واقعی نان</h4>
                                </div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="ps-block--award">
                                <div className="ps-block__header"><img src="/img/icon/tanvo-mahsoolat.png" alt=""/>
                                    <h4>تنوع محصولات</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

